<div class="ice-accordion-header">
  <div
    class="ice-card-header"
    [attr.data-testid]="testId()"
    [ngClass]="{ disabled: disabled, hover: !_isOpen }"
    (click)="_isOpen || disabled ? toggleAccordion.emit(false) : toggleAccordion.emit(true)"
  >
    <div class="header-content">
      @if (image || icon) {
        <div class="image-container" [ngClass]="imageBackgroundClass">
          @if (image) {
            @if (imagePillText) {
              <app-ice-img-pill pillSize="sm" [pillText]="imagePillText">
                <img class="header-image" [src]="image" />
              </app-ice-img-pill>
            } @else {
              <img class="header-image" [src]="image" />
            }
          } @else {
            @if (icon) {
              <mat-icon class="header-icon" matListIcon [svgIcon]="icon" />
            }
          }
        </div>
      }
    </div>
    <div class="content-text">
      <ng-content />
      @if (message) {
        <div class="header-badge">
          <app-ice-badge [type]="messageType">{{ message }}</app-ice-badge>
        </div>
      }
    </div>
    <div class="header-buttons">
      <button data-ignore-lint mat-icon-button [disabled]="disabled" [tabindex]="tab">
        <mat-icon
          class="rotate-animation"
          [ngClass]="{ 'rotate-animation-toggle': rotationState !== 'rotated' }"
          [svgIcon]="IconNames.ice_chevron_down"
        />
      </button>
      @if (showMenu) {
        <button
          data-ignore-lint
          mat-icon-button
          [matMenuTriggerFor]="menu"
          [tabindex]="tab"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      <mat-menu #menu="matMenu">
        <ng-content select="[menu-content]" />
      </mat-menu>
    </div>
  </div>
</div>
